import React, {useEffect, useContext, useRef, useState} from 'react';
import Link from "next/link";
import styled from "styled-components";
import LandingAreasSlider from "@organisms/property/landing/landing_areas_slider";
import IsOwnerBanner from "@molecules/banners/is.owner";
import IsRealtorBanner from "@molecules/banners/is.realtor";
import Carousel, {CarouselItem} from '@molecules/swiper/carousel';
import MostActiveRealtor from "@molecules/realtor/most_active_realtors";
import BrandingText from "@molecules/widgets/branding_text";
import {UserContext} from "@providers/user";
import {str_replace, isEmpty} from "@helpers/helpers";
import {array_chunk} from "@helpers/arrays";
import Icon from "@atoms/icon";
import {getSearchFaq} from "@organisms/property/helpers/search_helper";
import FaqsWidget from "@molecules/widgets/faqs";
import ApartmentIcon from '@icons/apartment.svg';
import HouseIcon from '@icons/house.svg';
import CommercialIcon from '@icons/commercial.svg';
import OfficeIcon from '@icons/office.svg';
import MostActiveAgencies from "../../../components/organisms/property/components/most_active_agencies";

const TehranHomeLanding = ({mostActiveRealtorsLists, searchNavbarRef, faqsList, setContactInfo, ssrBrandingText}) => {
    const cardRef = useRef('');
    const [faqs, setFaqs] = useState(faqsList ?? []);
    const userContext = useContext(UserContext);
    const authCheck = userContext.check;

    const districtProperties = [
        {caption: 'خرید آپارتمان در تهران', label: '259', url: '/املاک-تهران/خرید-فروش-آپارتمان'},
        {caption: 'خرید آپارتمان در پردیس', label: '3165', url: '/املاک-پردیس/خرید-فروش-آپارتمان'},
        {caption: 'خرید آپارتمان در اندیشه', label: '5098', url: '/املاک-اندیشه/خرید-فروش-آپارتمان'},
        {caption: 'خرید آپارتمان در پرند', label: '3573', url: '/املاک-پرند/خرید-فروش-آپارتمان'},
        {caption: 'خرید آپارتمان در اسلام‌شهر', label: '9288', url: '/املاک-اسلام-شهر/خرید-فروش-آپارتمان'},
        {caption: 'خرید آپارتمان در شهریار', label: '3548', url: '/املاک-شهریار/خرید-فروش-آپارتمان'},
        {caption: 'خرید آپارتمان در ملارد', label: '6951', url: '/املاک-ملارد/خرید-فروش-آپارتمان'},
        {caption: 'خرید آپارتمان در رباط کریم', label: '1442', url: '/املاک-رباط-کریم/خرید-فروش-آپارتمان'},
        {caption: 'خرید آپارتمان در قدس', label: '3848', url: '/املاک-قدس/خرید-فروش-آپارتمان'},
        {caption: 'خرید آپارتمان در پاکدشت', label: '3797', url: '/املاک-پاکدشت/خرید-فروش-آپارتمان'},
    ];
    const mostVisitedProperties = [
        {title: 'تهرانپارس'},
        {title: 'سعادت آباد'},
        {title: 'نارمک'},
        {title: 'پیروزی', url: 'خیابان-پیروزی'},
        {title: 'پاسداران'},
        {title: 'شهرک غرب'},
        {title: 'پونک'},
        {title: 'نیاوران'},
        {title: 'زعفرانیه'},
        {title: 'مرزداران'},
        {title: 'مجیدیه'},
        {title: 'ستارخان'},
        {title: 'ولنجک'},
        {title: 'فرشته'},
        {title: 'نصر (گیشا)'},
        {title: 'لواسان'},
        {title: 'الهیه'},
        {title: 'قیطریه'},
        {title: 'جردن'},
        {title: 'فرمانیه'},
    ];
    const mostVisitedPropertiesChunks = array_chunk(mostVisitedProperties, 5);

    useEffect(() => {
        const windowSize = window.innerWidth;
        if (!isEmpty(searchNavbarRef.current)) {
            if (windowSize > 991) {
                const handleScroll = (event) => {

                    if (window.pageYOffset > 82) {
                        searchNavbarRef.current.classList.add('fixed-top');
                        if (!isEmpty(cardRef.current)) {
                            cardRef.current.classList.add('search-navbar-fixed');
                        }

                        if (!isEmpty(document.querySelector('.landing-page-container'))) {
                            document.querySelector('.landing-page-container').classList.add('search-navbar-fixed');
                        }
                    } else {
                        searchNavbarRef.current.classList.remove('fixed-top');
                        if (!isEmpty(cardRef.current)) {
                            cardRef.current.classList.remove('search-navbar-fixed');
                        }

                        if (!isEmpty(document.querySelector('.landing-page-container'))) {
                            document.querySelector('.landing-page-container').classList.remove('search-navbar-fixed');
                        }
                    }
                };

                window.addEventListener('scroll', handleScroll);
                return () => {
                    window.removeEventListener("scroll", handleScroll);
                };
            } else {
                searchNavbarRef.current.classList.remove('fixed-top');
                if (!isEmpty(cardRef.current)) {
                    cardRef.current.classList.remove('search-navbar-fixed');
                }

                if (!isEmpty(document.querySelector('.landing-page-container'))) {
                    document.querySelector('.landing-page-container').classList.remove('search-navbar-fixed');
                }
            }
        }
    });

    useEffect(() => {
        if (!faqs.length) {
            const params = {
                city_id: 259,
            };

            getSearchFaq(params, 'home').then(widgets => {
                setFaqs(widgets)
            });
        }
    }, []);

    const LandingAreasSliderBreakpoints = {
        1024: {
            slidesPerView: 5,
        },
        768: {
            slidesPerView: 3.2,
        },
        320: {
            slidesPerView: 2.2,
        }
    };

    const mostDistrictsSliderBreakpoints = {
        1024: {
            slidesPerView: 4,
        },
        768: {
            slidesPerView: 3.2,
        },
        320: {
            slidesPerView: 1.5,
        }
    };

    return (
        <Container ref={cardRef} className="mb-56">
            <Sections className="mt-16 mt-lg-56">
                <div className="container">
                    <h1 className="mb-16">املاک تهران</h1>
                </div>

                <RegionSlider className="container sm-fluid">
                    <LandingAreasSlider
                        items={districtProperties}
                        breakpoints={LandingAreasSliderBreakpoints}
                    />
                </RegionSlider>
            </Sections>

            <Sections className="mt-40 mt-lg-56">
                <p className="container"><strong className="h2">املاک پربازدید شهر تهران</strong></p>

                <div className={"most-visited-properties-wrapper container sm-fluid"}>
                    <Carousel breakpoints={mostDistrictsSliderBreakpoints} pagination={false} navigation_show={false}>
                        {
                            (mostVisitedPropertiesChunks).map(mostVisitedPropertiesChunk => {
                                return (
                                    <CarouselItem className="">
                                        {mostVisitedPropertiesChunk.map(mostVisitedProperty => {
                                            let urlDistrictName = str_replace(' ', '-', !isEmpty(mostVisitedProperty.url) ? mostVisitedProperty.url : mostVisitedProperty.title);

                                            if (urlDistrictName.includes('(')) {
                                                urlDistrictName = str_replace('(', '(-', urlDistrictName);
                                            }

                                            if (urlDistrictName.includes(')')) {
                                                urlDistrictName = str_replace(')', '-)', urlDistrictName);
                                            }


                                            return (
                                                <Link href="/properties" as={'/املاک-تهران/خرید-فروش-آپارتمان/' + urlDistrictName}>
                                                    <a className="text-hover-green">خرید آپارتمان در {mostVisitedProperty.title}</a>
                                                </Link>
                                            )
                                        })}
                                    </CarouselItem>
                                )
                            })
                        }
                    </Carousel>
                </div>
            </Sections>


            <Sections className="selected-realtors js-most-active-agency-section">

                <div className="container sm-fluid">
                    <MostActiveAgencies
                        city_id={259}
                        setContactInfo={setContactInfo}
                        className=""
                        sectionTitle={`املاک منتخب تهران`}
                    />
                </div>
            </Sections>

            {
                !authCheck ?
                    <Sections className="container is-owner-banner-wrapper">
                        <IsOwnerBanner/>
                    </Sections> :
                    ''
            }

            <Sections className={"container "}>
                <p className="mb-24 mb-lg-16"><strong className="h2">رهن و اجاره در تهران</strong></p>

                <div className="row">
                    <div className="col-6 col-lg-3">
                        <Link href="/properties" as="/املاک-تهران/رهن-اجاره-آپارتمان">
                            <a>
                                <div className="bg-info py-32 text-center rounded-8 bg-info-hover">
                                    <Icon height="35"><ApartmentIcon/></Icon>
                                    <div className="font-weight-500">اجاره آپارتمان</div>
                                </div>
                            </a>
                        </Link>
                    </div>

                    <div className="col-6 col-lg-3">
                        <Link href="/properties" as="/املاک-تهران/رهن-اجاره-خانه-ویلایی">
                            <a>
                                <div className="bg-info py-32 text-center rounded-8 bg-info-hover">
                                    <Icon height="35"><HouseIcon/></Icon>
                                    <div className="font-weight-500">اجاره خانه ویلایی</div>
                                </div>
                            </a>
                        </Link>
                    </div>

                    <div className="col-6 col-lg-3">
                        <Link href="/properties" as="/املاک-تهران/رهن-اجاره-مغازه-تجاری">
                            <a>
                                <div className="bg-info py-32 mt-16 mt-lg-0 text-center rounded-8 bg-info-hover">
                                    <Icon height="35"><CommercialIcon/></Icon>
                                    <div className="font-weight-500">اجاره مغازه</div>
                                </div>
                            </a>
                        </Link>
                    </div>

                    <div className="col-6 col-lg-3">
                        <Link href="/properties" as="/املاک-تهران/رهن-اجاره-دفتر-کار-اداری">
                            <a>
                                <div className="bg-info py-32 mt-16 mt-lg-0 text-center rounded-8 bg-info-hover">
                                    <Icon height="35"><OfficeIcon/></Icon>
                                    <div className="font-weight-500">اجاره دفتر کار</div>
                                </div>
                            </a>
                        </Link>
                    </div>
                </div>
            </Sections>


            <Sections className="js-active-realtors-last-week">
                <div className="container">
                    <p className="mb-16"><strong className="h2">کارشناس‌های املاک فعال 7 روز اخیر تهران</strong></p>
                </div>
                <div className="container sm-fluid">
                    <MostActiveRealtor
                        city_id={259}
                        last_week={true}
                        mostActiveRealtorsLists={mostActiveRealtorsLists}
                        sectionClassName="js-active-realtors-last-week"
                    />
                </div>
            </Sections>


            {
                (!authCheck) ?
                    <Sections className={"container is-realtor-banner-wrapper "}>
                        <IsRealtorBanner/>
                    </Sections> :
                    ''
            }

            {
                (faqs.length) ?
                    <Sections className="container ">
                        <FaqsWidget faqs={faqs}/>
                    </Sections>
                    : ''
            }

            <Sections className={"container "}>
                <BrandingText skeleton={false} content={ssrBrandingText} searchParams={{city_id: 259}}/>
            </Sections>
        </Container>
    );
}

export default React.memo(TehranHomeLanding);

// styles

const Container = styled.div`

  &.search-navbar-fixed {
    margin-top: 120px !important;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      margin-top: 0 !important;
    }
  }

  .most-visited-properties-wrapper {
    a {
      display: block;
      width: 100%;
      margin-top: 16px;
    }
  }
`;

const Sections = styled.section`
  margin-top: 80px;

  .text-hover-green {
    &:hover {
      color: ${props => props.theme.secondary};
    }
  }

  &.is-realtor-banner-wrapper {
    margin-top: 136px !important;
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-top: 64px;

    &.is-realtor-banner-wrapper {
      margin-top: 40px !important;
    }
  }
`;

const RegionSlider = styled.div`

  .tehran-region-skeleton {
    height: 130px !important;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      height: 90px !important;
    }
  }

  .slider-image {
    min-height: 130px;
    height: 130px;
    max-height: 130px;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      min-height: 90px;
      height: 90px;
      max-height: 90px;
    }
  }

  .areas-slider-title {
    @media (max-width: ${props => props.theme.screenSmMax}) {
      display: block !important;
      position: relative;
      text-overflow: inherit;
      white-space: inherit;
      overflow: inherit;

      .icons {
        display: inline-flex !important;
        vertical-align: middle;
        margin-right: 8px;
      }
    }
  }
`;